import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { ArrowLeft, UserX } from 'lucide-react';
import CustomerDetails from './containers/CustomerDetails';
import { get_customer, get_customer_address } from './redux/reducer';
import { getCustomer, getLoading, getAddress } from './redux/selectors';

const Skeleton = ({ className }) => (
  <div className={`animate-pulse rounded-lg bg-[#F3F4F6] ${className}`} />
);

const LoadingState = () => (
  <div className="space-y-6">
    <div className="flex gap-4 items-center p-6 bg-white rounded-xl border border-[#E9E9E9]">
      <Skeleton className="w-16 h-16 !rounded-full" />
      <div className="space-y-2">
        <Skeleton className="w-48 h-5" />
        <Skeleton className="w-32 h-4" />
      </div>
    </div>
    <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
      <Skeleton className="h-[220px] !rounded-xl" />
      <Skeleton className="h-[220px] !rounded-xl" />
    </div>
  </div>
);

const Customer = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const params = useParams();
  const loading = useSelector(getLoading);
  const customer = useSelector(getCustomer);
  const address = useSelector(getAddress);
  const requested = useRef(false);

  useEffect(() => {
    requested.current = true;
    dispatch(get_customer(params.id));
    dispatch(get_customer_address(params.id));
  }, [dispatch, params.id]);

  // The store keeps the last viewed user, so wait until it matches this route.
  const isReady = !loading && customer?._id === params.id;
  const notFound = requested.current && !loading && !isReady;

  return (
    <div className="px-5 py-6 font-outfit">
      <button
        onClick={() => history.goBack()}
        className="flex gap-1.5 items-center mb-5 text-[14px] font-medium text-[#6B7280] hover:text-[#1F2937] transition-colors"
      >
        <ArrowLeft size={16} />
        Back
      </button>

      {isReady ? (
        <CustomerDetails customer={customer} address={address} />
      ) : notFound ? (
        <div className="flex flex-col items-center py-20 text-center bg-white rounded-xl border border-[#E9E9E9]">
          <div className="grid place-items-center w-12 h-12 rounded-full bg-[#FEF2F2] text-[#EF4444]">
            <UserX size={22} />
          </div>
          <p className="mt-4 text-[16px] font-semibold text-[#1F2937]">
            We couldn't load this user
          </p>
          <p className="mt-1 text-[14px] text-[#6B7280]">
            They may have been removed, or the link is incorrect.
          </p>
        </div>
      ) : (
        <LoadingState />
      )}
    </div>
  );
};

export default Customer;
